
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component({
    components: {},
  })
  export default class AuthSubTitle extends Vue {
    @Prop({ type: String, default: "" }) readonly content?: string;
  }
